sap.ui.define(["sap/ui/core/library", 'sap/uxap/BlockBase'], function (coreLibrary, BlockBase) {
	"use strict";

	var ViewType = coreLibrary.mvc.ViewType;

	var Teams = BlockBase.extend("com.reply.leaviosa.blocks.teams.Teams", {
		metadata: {
			views: {
				Collapsed: {
					viewName: "com.reply.leaviosa.blocks.teams.Teams",
					type: ViewType.XML
				},
				Expanded: {
					viewName: "com.reply.leaviosa.blocks.teams.Teams",
					type: ViewType.XML
				}
			}
		}
	});
    
	return Teams;
});